import React from 'react';
import ReactDOM from 'react-dom';
import Form from './Pages/Form/index'
import 'antd/dist/antd.css';

ReactDOM.render(
  <div>
    <Form />
  </div>,
  document.getElementById('root')
);

